import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { FormioOptions } from 'angular-formio';

@Component({
  selector: 'app-html-canvas',
  templateUrl: './html-canvas.component.html',
  styleUrls: ['./html-canvas.component.scss']
})
export class HtmlCanvasComponent implements OnInit {

  public form: Object = {
    components: []
  };
  @ViewChild('json') jsonElement?: ElementRef;
  
  formioOptions: FormioOptions = {
    disableAlerts: true,
  }

  uploadedDocument:boolean = false;
  allParticipant:boolean = false;
  TemplateName:boolean = false;
  showToolsLeft:boolean = false;
  data: any;
  rendered:boolean=false;
  
  addBootstrap(){
    const cssURL = "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css";
    const node = document.createElement('link');
    node.href = cssURL;
    node.rel = 'stylesheet';
    const s = document.getElementsByTagName('head')[0]
    s.parentNode.insertBefore(node, s);

    // const cssURL = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css  ";
    // const node = document.createElement('script');
    // node.src = cssURL;
    // node.type = 'text/javascript';
    // document.getElementsByTagName('head')[0].appendChild(node);

  }

  constructor(private dialog: MatDialog,private elRef:ElementRef) { 
    this.addBootstrap();
  }

   options = {
    builder: {
      custom: {
        title: 'User Fields',
        weight: 10,
        components: {
          firstName: {
            title: 'First Name',
            key: 'firstName',
            icon: 'terminal',
            schema: {
              label: 'First Name',
              type: 'textfield',
              key: 'firstName',
              input: true,
              asffa:1
            }
          },
          lastName: {
            title: 'Last Name',
            key: 'lastName',
            icon: 'terminal',
            schema: {
              label: 'Last Name',
              type: 'textfield',
              key: 'lastName',
              input: true
            }
          },
          email: {
            title: 'Email',
            key: 'email',
            icon: 'at',
            schema: {
              label: 'Email',
              type: 'email',
              key: 'email',
              input: true
            }
          },
          phoneNumber: {
            title: 'Mobile Phone',
            key: 'mobilePhone',
            icon: 'phone-square',
            schema: {
              label: 'Mobile Phone',
              type: 'phoneNumber',
              key: 'mobilePhone',
              input: true
            }
          }
        }
      },
      layout: {
        components: {
          table: true
        }
      }
    }
  }
  ngOnInit(): void {
    //this.addBootstrap();
    this.form = 'https://examples.form.io/example';
  }
  ngAfterContentInit() {
    // assume dynamic HTML was added before
    this.elRef.nativeElement.querySelector('.btn-danger').addEventListener('click', this.onSubmitCustomForm.bind(this));
  }
  onRendered () {
    this.rendered = true;
  }
  onSubmit(event) {
    alert('form submitted!')
  }

  onSubmitCustomForm(){
    alert('Curstom alert submitted!')
  }
  showTools(){
    this.showToolsLeft = !this.showToolsLeft
  }

  close() {
    this.dialog.closeAll();
  }
  onChange(event) {
    //this.aray=event.builder.builder;
    if (event.data) {
      this.data = event.data;
    }
    //this.jsonElement.nativeElement.innerHTML = '';
   // this.jsonElement.nativeElement.appendChild(document.createTextNode(JSON.stringify(event.form, null, 4)));
  
  }
  saveProject(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    })
  }

  movies = [
    'Rent Agreement Exclusive',
    'Home Agreemnt Of New Property',
    'Patient Report Of Covide',
  ];

  showTemplate(){
    this.TemplateName = !this.TemplateName
  }


  addFolder(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  showUploadDocuments(){
    this.uploadedDocument = !this.uploadedDocument;
    this.allParticipant = false;
  }  
  showAllParticipant(){
    this.allParticipant = !this.allParticipant;
    this.uploadedDocument = false;
  }
  
  assignUser(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }


  todo = [
    {
      role: 'Buyer',
      name: 'Jagdish Singh',
      email: 'jagdishk@smartdatainc.net',
      pic: '../../../../assets/images/avatars/Nancy.jpg'
    }
  ];

  done = [
    {
      role: 'Employee',
      name: 'Surender Kumar',
      email: 'surender.dz@smartdatainc.net',
      pic: '../../../../assets/images/avatars/garry.jpg'
    },
    {
      role: 'Administrator',
      name: 'Matt Maclpin',
      email: 'matt@gmail.com',
      pic: '../../../../assets/images/avatars/Copeland.jpg'
    },
    
  ];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }

    moveItemInArray(this.movies, event.previousIndex, event.currentIndex);


  }



  peoples =[
    {
      name : 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',
      role: 'Buyer' 
    },
    {
      name : 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',     
      role: 'Doctor'   
    },
    {
      name : 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',    
      role: 'Patient'      
    },
    {
      name : 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg', 
      role: 'Nurse'         
    },
    {
      name : 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',    
      role: 'Employee'      
    },
    
    
  ]

}